import * as moment from 'moment';
import * as _ from 'lodash';
import { parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
/**
 * Helper function for formatting the date in a human-readable format.
 *
 * **Note**: This function will format in UTC.
 *
 * @param date - The date to format. Either as a string, Date object, or Moment object.
 * @param truncateMonth - Whether or not to truncate the month (ie January -> Jan)
 * @returns The string formatted date.
 */
export const prettyMDY = (date: Date | moment.Moment | string, truncateMonth?: boolean): string => {
  let dateToFormat: Date;
  if (moment.isMoment(date)) {
    dateToFormat = date.toDate();
  } else if (_.isString(date)) {
    dateToFormat = new Date(date.replace(/-/g, '/'));
  } else {
    dateToFormat = parseISO(date.toISOString());
  }

  return formatInTimeZone(dateToFormat, 'Etc/Greenwich', truncateMonth ? 'LLL d, yyyy' : 'LLLL d, yyyy');
};
